import PropTypes from 'prop-types';

export default {
  displayName: PropTypes.string,
  id: PropTypes.string,
};
